import {HttpClient} from "../../service/httpClient/HttpClient";
import moment from "jalali-moment";
import {setLoadingStateDispatch} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes} from "../../context/SnackBarContext";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";
import {doDownloadFile} from "../../utils/DownloadHelper";

export class CashService {
    token;
    loading;
    snackbar;

    constructor(token, loading, snackbar, fundID) {
        this.token = token;
        this.loading = loading;
        this.snackbar = snackbar;
        this.fundID = fundID

        this.httpClient = new HttpClient()
    }


    getCashInfo(fundID) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                "fund-presentation/funds/" + fundID,
                this.httpClient.prepareUserAccessHeader(this.token)
            ).then(response => resolve(response))
                .catch(reason => reject(reason))
        })
    }


    getAvailableCashList() {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                "fund-presentation/funds",
                this.httpClient.prepareUserAccessHeader(this.token)
            ).then(response => resolve(response))
                .catch(reason => reject(reason))
        })
    }

    prepareFundInfoData(name, muxNumGroup, monthlyMeetingDay, fixedFeeRate, activityStartDate, minimumAmount, lastDay, address) {
        return {
            "name": name,
            "maximumGroupNumber": muxNumGroup,
            "dateOfMeetingPerMonth": monthlyMeetingDay,
            "fixedFeeRate": fixedFeeRate,
            "minimumAmountReceivedPerMonth": minimumAmount,
            "theLastDayAllowedToReceiveSavingsPerMonth": lastDay,
            "activityStartDate": moment.from(activityStartDate, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD'),
            "postalAddress": address,
        }
    }

    updateFundInfo(fundInfo, fundID) {
        this.loading(setLoadingStateDispatch(true))
        this.httpClient.put(
            "fund-presentation/funds/" + fundID,
            this.httpClient.prepareUserAccessHeader(this.token),
            fundInfo
        ).then(_ => {
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "بروز رسانی اطلاعات صندوق با موفقیت انجام شد."))
            this.loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            ServerErrorHandler(reason, "خطا در بروزرسانی اطلاعات صندوق!", this.snackbar, this.loading)
        })
    }

    getCashReports(reportType, cashName) {
        this.loading(setLoadingStateDispatch(true))
        this.httpClient.getFile(
            `fund-presentation/funds/${this.fundID}/reports/${reportType.id}`,
            this.httpClient.prepareUserAccessHeader(this.token)
        ).then(response => {

            doDownloadFile(response, `خلاصه وضعیت ${cashName}`, reportType.type)

            this.loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            ServerErrorHandler(
                reason,
                "خطا در دریافت فایل گزارش",
                this.snackbar,
                this.loading
            )
        })
    }
}